import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Service prices and order charges are stored with four-decimal precision.
export function formatServiceCurrency(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 'Price unavailable';
  if (value > 0 && value < 0.00005) return '<$0.0001';
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: 2, maximumFractionDigits: 4,
  }).format(value);
}

export function formatProviderBalance(amount, currency = 'USD') {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 'Balance unavailable';
  const code = String(currency || 'USD').toUpperCase();
  const number = value.toFixed(5);
  return code === 'USD' ? `$${number} USD` : `${number} ${code}`;
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatRelativeTime(date) {
  const now = new Date();
  const then = new Date(date);
  const seconds = Math.floor((now - then) / 1000);
  
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return formatDate(date);
}

export function getStatusColor(status) {
  const colors = {
    pending: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    processing: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    in_progress: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
    completed: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    partial: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    canceled: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30',
    refunded: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    open: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    answered: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    closed: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30',
    failed: 'bg-red-500/20 text-red-400 border-red-500/30',
  };
  return colors[status] || 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30';
}

export function getPriorityColor(priority) {
  const colors = {
    low: 'bg-zinc-500/20 text-zinc-400',
    medium: 'bg-yellow-500/20 text-yellow-400',
    high: 'bg-red-500/20 text-red-400',
  };
  return colors[priority] || 'bg-zinc-500/20 text-zinc-400';
}
